<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <div class="alert alert-info" v-if="notice">{{ notice }}</div>
                <div class="alert alert-danger" v-if="error">{{ error }}</div>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerifyEmail',
  data () {
    return {
      uid: '',
      error: '',
      notice: 'Progressing...'
    }
  },
  mounted () {
    this.verifyEmail()
  },
  methods: {
    async verifyEmail () {
      const uidHash = this.$route.query.uidHash
      console.log('uidHash: ', uidHash)
      if (!uidHash) {
        this.verifyFailed('Invalid link!  Please click from your email.')
        return
      }

      try {
        const response = await this.$http.get('/api/verifyEmail?uidHash=' + uidHash)
        console.debug('reset password: ', response)
        if (response && response.data && response.data.code === 0) {
          this.verifySuccessful(response)
        } else {
          const errorMsg = response ? (response.data ? (response.data.msg ? response.data.msg: 'something wrong!'): 'something wrong!'): 'something wrong!'
          this.verifyFailed(response.data.msg)
        }
      } catch(error) {
        const errorMsg = error.response ? (error.response.data ? (error.response.data.msg? error.response.data.msg: error.message): error.message): error.message
        this.verifyFailed(errorMsg)
      } 
    },
    verifySuccessful (response) {
      this.notice = 'Email Verfied! Please login.'
      this.error = ''
      this.password = ''
      this.password_confirmation = ''
      this.enableResetForm = false
    },
    verifyFailed (errorMessage) {
      this.error = (errorMessage) || 'Something went wrong'
      this.notice = ''
    }
  }
}
</script>
